export default __webpack_public_path__ + "static/media/lob.62314edc.jpg";